export const FACEBOOK = 'FACEBOOK'
export const PINTEREST = 'PINTEREST'
export const TWITTER = 'TWITTER'
export const EMAIL = 'EMAIL'
export const FACEBOOK_HOVER = 'FACEBOOK_HOVER'
export const PINTEREST_HOVER = 'PINTEREST_HOVER'
export const TWITTER_HOVER = 'TWITTER_HOVER'
export const EMAIL_HOVER = 'EMAIL_HOVER'
